import React from "react";
import {Modal as BootStrapModal} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import styles from "./BillingRequiredModal.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamationTriangle, faFileInvoice} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";

export default function BillingRequiredModal({show, missingFields, onClose}) {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const fieldLabels = {
        'tax_id': t('pricing.fieldLabels.tax_id'),
        'business_name': t('pricing.fieldLabels.business_name'),
        'address': t('pricing.fieldLabels.address'),
        'city': t('pricing.fieldLabels.city'),
        'state': t('pricing.fieldLabels.state'),
        'postal_code': t('pricing.fieldLabels.postal_code'),
        'country': t('pricing.fieldLabels.country'),
        'billing_email': t('pricing.fieldLabels.billing_email'),
        'billing_phone': t('pricing.fieldLabels.billing_phone')
    };

    const handleGoToBilling = () => {
        onClose();
        navigate('/settings/payments');
    };

    return (
        <BootStrapModal show={show} onHide={onClose} centered>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <div className={styles.warningIcon}>
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                    </div>
                    <h2 className={styles.title}>{t('pricing.billingRequired')}</h2>
                    <p className={styles.subtitle}>
                        {t('pricing.billingRequiredSubtitle')}
                    </p>
                </div>

                <div className={styles.body}>
                    <div className={styles.infoIcon}>
                        <FontAwesomeIcon icon={faFileInvoice} />
                    </div>

                    {missingFields && missingFields.length > 0 && (
                        <div className={styles.missingFieldsSection}>
                            <p className={styles.missingLabel}>{t('pricing.missingFields')}</p>
                            <ul className={styles.missingList}>
                                {missingFields.map((field, index) => (
                                    <li key={index} className={styles.missingItem}>
                                        {fieldLabels[field] || field}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <p className={styles.description}>
                        {t('pricing.billingRequiredDescription')}
                    </p>
                </div>

                <div className={styles.footer}>
                    <button className={styles.cancelButton} onClick={onClose}>
                        {t('common.cancel')}
                    </button>
                    <button className={styles.primaryButton} onClick={handleGoToBilling}>
                        {t('pricing.goToBilling')}
                    </button>
                </div>
            </div>
        </BootStrapModal>
    );
}
